import React from 'react'
import { Row, Col } from 'rsuite'

export default function CheckboxColView(props) {
  const { schema } = props
  const col = props.column ? props.column : 1
  // console.log('schema ', schema)
  return (
    <div>
      <Row>
        {schema.options &&
          schema.options.map((item, index) => {
            if (schema.optionSelected.some((e) => e === item.value)) {
              return (
                <Col
                  key={index}
                  xs={24}
                  sm={12}
                  md={Math.floor(24 / col)}
                  lg={Math.floor(24 / col)}
                  style={{ marginBottom: 5 }}
                >
                  <span> &#9679; {item.label}</span>
                </Col>
              )
            }
          })}

        {schema.inputOther?.value && (
          <Col xs={24} sm={12} md={Math.floor(24 / col)} lg={Math.floor(24 / col)}>
            <span> &#9679; {schema.inputOther.label}</span>
            <span>
              <b> : </b>
              {schema.inputOther.value}
            </span>
          </Col>
        )}

        {schema.optionSelected?.length === 0 && schema.inputOther?.isSelected != true && (
          <Col xs={24} sm={12} md={8} lg={8}>
            <span>
              {schema.disabledAllCheckbox && schema.disabledAllCheckbox.value === true
                ? schema.disabledAllCheckbox.label
                : '- ไม่ได้ระบุ -'}
            </span>
          </Col>
        )}
      </Row>
    </div>
  )
}
